import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '@components/header/header.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { SalesSupportComponent } from './sales-support.component';
import { SalesSupportRoutingModule } from './sales-support-routing.module';
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component';
import { SelectComponent } from '@components/select/select.component';
import { ButtonComponent } from '@components/button/button.component';

@NgModule({
  declarations: [SalesSupportComponent],
  imports: [
    CommonModule,
    SalesSupportRoutingModule,
    HeaderComponent,
    TranslateModule,
    FormsModule,
    ConfirmModalComponent,
    SelectComponent,
    ButtonComponent
  ]
})
export class SalesSupportModule {}